<template>
  <el-row type="flex" class="row-bg" justify="center" v-if="submission && activity">
    <div class="grid-content bg-purple-dark">
      <div class="box">
        <el-row type="flex" class="row-bg"
                v-if="thumb"
                justify="center" align="middle"
                style="width: 100%; max-height: 280px;overflow: hidden">
          <img :src="thumb" style="width: 100%;height: auto;">
        </el-row>
        <el-row type="flex" class="thumb flex" v-else=""
             justify="center" align="middle"
             :style="{'background-image':'url('+thumb+')'}">
          <pre v-if="submission.submissionMaterialList[0].activityMaterialType=='WordMaterialType'"
               class="thumb-text">{{submission.submissionMaterialList[0].exif.text}}</pre>
          <div style="text-align: center" v-if="submission.submissionMaterialList[0].activityMaterialType=='DocumentMaterialType'">
              <img :src="submission.submissionMaterialList[0].icon"/>
            <div class="fileName">{{submission.submissionMaterialList[0].exif.name}}</div>
          </div>
        </el-row>
        <div class="info">
          <div class="title text-cut2">{{submission.name}}</div>
          <el-row type="flex" style="margin: 10px 0;" v-if="submission.autograph">
            <div class="owner">作者</div>
            <div class="owner-text">{{submission.autograph}}</div>
          </el-row>
          <div class="desc text-cut2" v-if="submission.description">{{submission.description}}</div>
        </div>
      </div>
      <brand style="margin-top: 50px;" :submission="submission" :activity="activity"></brand>
      <wxlite class="hidden-sm-and-up" :submission="submission" :activity="activity">
        查看详情
      </wxlite>
    </div>
  </el-row>
</template>

<script>
  import App from '../util/comfun'
  import brand from '../components/brand.vue'
  import wxlite from '../components/wxlite.vue'
  import 'element-ui/lib/theme-chalk/display.css';
  export default {
    name: 'submission',
    data () {
      return {
        thumb:'',
        submission:null,
        material:null,
        activity:null,
      }
    },
    components:{
      brand,
      wxlite,
    },
    methods:{
      getDetail(){
        App.Works.GetWorksById({id:this.options.id}).then(res=>{
          if(res.code!=200) return this.$message({
            type:'error',
            message:'咦...链接不正确或网络不稳定，请检查后重试!',
            duration:-1,
          })
          let submission=res.data.submissionMaterialList[0]
          if(submission.exif){
            try{submission.exif=JSON.parse(submission.exif)}catch (e){}
          }
          if(submission.coverInfo && typeof submission.coverInfo=='string'){
            try{submission.coverInfo=JSON.parse(submission.coverInfo)}catch (e){}
          }
          if(submission.exif){
            App.setPlayerUrl(submission)
            switch (submission.exif.type/1){
              case 1:
                this.thumb=submission.playerUrl+'?imageMogr2/1/w/750';
                break;
              case 2:
                this.thumb=submission.url+'?vframe/jpg/offset/1/w/750';
                break;
              case 3:
                break;
              case 4:
                submission.icon = 'https://assets.pfotoo.com/file/' + submission.exif.mark + '.svg';
                break;
              case 5:
                if(submission.coverInfo.url.indexOf('thumb.png')>0){
                  this.thumb = submission.coverInfo.url.replace('thumb.png','thumb.jpg');
                }else{
                  this.thumb = submission.coverInfo.url+'?imageMogr2/thumbnail/100000@';
                }
                break;
            }
          }
          res.data.description=(res.data.description||'').replace(/<[^>]+>/g,'')
          this.submission=res.data
          this.submission.thumb=this.thumb
        })
      },
      getActivityDetail(){
        App.Contribution.GetContributionById({id:this.options.activityId}).then(res=>{
          if(res.code==200){
            this.activity=res.data
            this.adinit()
          }else{
            this.activity={}
          }
        })
      },
      adinit(params={}){
        if(this.activity.activityAuth.isAdvertisement==1) return;
        // 全局命名空间申明TencentGDT对象
        window.TencentGDT = window.TencentGDT || [];
        // 广告初始化
        window.TencentGDT.push({
          app_id: '1207383851', // {String} - appid - 必填
          placement_id: '9142009522043212', // {String} - 广告位id - 必填
          type: 'interstitial', // {String} - 原生广告类型 - 必填
          //muid_type: '1', // {String} - 移动终端标识类型，1：imei，2：idfa，3：mac号 - 选填
          //muid: '******', // {String} - 加密终端标识，详细加密算法见API说明 -  选填
          count: 1, // {Number} - 拉取广告的数量，默认是3，最高支持10 - 选填
          onComplete: function(res) {
            console.log('adinit.onComplete',res)
            if (res && res.ret === 0) {
              // 原生模板广告位调用 window.TencentGDT.NATIVE.renderAd(res[0], 'containerId') 进行模板广告的渲染
              // res[0] 代表取广告数组第一个数据
              TencentGDT.NATIVE.renderAd(res.data[0]);
            } else {
              // 加载广告API，如广告回调无广告，可使用loadAd再次拉取广告
              // 注意：拉取广告频率每分钟不要超过20次，否则会被广告接口过滤，影响广告位填充率
              setTimeout(function() {
                window.TencentGDT.NATIVE.loadAd('9142009522043212')
              }, 3000)
            }
          }
        });

        // H5 SDK接入全局只需运行一次
        (function () {
          var doc = document,
            h = doc.getElementsByTagName('head')[0],
            s = doc.createElement('script');
          s.async = true;
          s.src = 'https://qzs.gdtimg.com/union/res/union_sdk/page/h5_sdk/i.js';
          h && h.insertBefore(s, h.firstChild)
        })();
      },
    },
    mounted(){
      this.options=this.$route.params
      console.log(this.options)
      this.getDetail()
      if(this.options.activityId){
        this.getActivityDetail()
      }else{
        this.activity={}
      }
    },

  }
</script>

<style scoped>
  .bg-purple-dark {
    background: #ffffff;
    max-width: 375px;
    min-width: 345px;
    box-sizing: border-box;
    margin: 40px auto 10px;
    overflow-x: hidden;
  }
  .box{
    width: 335px;
    opacity: 1;
    background: linear-gradient(180deg,#ffffff, #ffffff 100%);
    border-radius: 2px;
    box-shadow: 0px 2px 4px 0px rgba(208,207,207,0.50);
    margin: 10px auto 0;
  }
  .thumb{
    width: 335px;
    height: 280px;
    opacity: 1;
    background-size: cover;
    background-color: #eef2f2;
    overflow: hidden;
  }
  .info{
    box-sizing: border-box;
    padding: 10px 10px 30px;
  }
  .text-cut2{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .title{
    opacity: 1;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #5d5d5d;
    line-height: 25px;
  }
  .desc{
    opacity: 1;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #999999;
    line-height: 20px;
  }
  .owner{
    width: 40px;
    height: 15px;
    opacity: 1;
    background: #f3f9f9;
    border-radius: 2px;

    opacity: 1;
    font-size: 10px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3dc4a7;
    line-height: 15px;
  }
  .owner-text{
    height: 17px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #666666;
    line-height: 17px;
    margin-left: 5px;
  }
  .hidden-sm-and-up{
    margin: 42px auto 0;
  }
  .thumb-text{
    padding: 10px;
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #353535;
    line-height: 22px;

    overflow: hidden;
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
    max-height: 250px;
  }
  .fileName{
    width: 255px;
    height: 50px;
    opacity: 0.8;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #353535;
    line-height: 25px;
    text-shadow: 0px 2px 4px 0px rgba(208,207,207,0.50);
    margin-top: 21px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/submission.vue